import React, {useContext} from 'react'
import {PopupClose} from "./PopupClose";
import {PopupCloseCancel} from "./PopupCloseCancel";
import {IsPopupActiveContext} from "../PopupList";
import axios from "axios";
import {getApiLink} from "../../../functions/getApiLink";
import {useDispatch, useSelector} from 'react-redux';
import {updateSummaryEmployeeStatus} from "../../../storage/toolkit";
import {Translate} from "../../translate/Translate";
import {toast} from "react-toastify";

interface IPopupReviewToTimesheetProps {
    data: any
}

export const PopupReviewToTimesheet: React.FC<IPopupReviewToTimesheetProps> = ({data}) => {

    const setIsPopupActive: any = useContext(IsPopupActiveContext)

    const summaryEmployees: any = useSelector((state: any) => state.toolkit.summaryEmployees)

    const dispatch = useDispatch()

    const findPreviousStatus = (timesheetId: string): string | null => {
        const lists = [summaryEmployees?.all, summaryEmployees?.favourite]
        for (const list of lists) {
            if (!Array.isArray(list)) continue
            const match = list.find((t: any) => t?.id === timesheetId)
            if (match) return match.status
        }
        return null
    }

    const handleReview = () => {
        const timesheetId = data?.timesheetId
        const newStatus = data?.status
        if (!timesheetId || !newStatus) {
            setIsPopupActive(false)
            return
        }

        const previousStatus = findPreviousStatus(timesheetId)

        // Optimistic update — UI reacts immediately, network request runs in background.
        dispatch(updateSummaryEmployeeStatus({timesheetId, status: newStatus}))
        setIsPopupActive(false)

        axios.post(getApiLink(`/api/timesheet/employees/review/?timesheet_id=${timesheetId}&status=${newStatus}`))
            .then(({data: response}) => {
                if (!response?.status) {
                    if (previousStatus !== null) {
                        dispatch(updateSummaryEmployeeStatus({timesheetId, status: previousStatus}))
                    }
                    toast.error("Failed to update timesheet status")
                }
            })
            .catch(() => {
                if (previousStatus !== null) {
                    dispatch(updateSummaryEmployeeStatus({timesheetId, status: previousStatus}))
                }
                toast.error("Failed to update timesheet status")
            })
    }

    return (
        <div className="approve-timesheet__body popup-body">
            <PopupClose/>
            <div className="approve-timesheet__container popup-container" data-simplebar="init"
                 data-simplebar-auto-hide="false">
                <div className="simplebar-content">
                    <h2 className="approve-timesheet__title title popup-title">

                        {
                            data.status === "approve" ? <Translate>employees_page.other.confirm_approve_timesheet</Translate> : <Translate>employees_page.other.confirm_reject_timesheet</Translate>
                        }

                    </h2>
                    <div className="approve-timesheet__buttons">
                        <PopupCloseCancel/>
                        <button onClick={handleReview} className="approve-timesheet__submit btn" type="submit">
                            <Translate>employees_page.other.continue</Translate>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
